import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class FocusBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.focus;
    }
}
export default FocusBehavior;
